import type { PayloadAction } from '@reduxjs/toolkit';
import api from 'Cloud/Application/api';
import {
    createSharedAutoDeleteStart,
    createSharedAutoDeleteSuccess,
    loadSharedAutoDeleteRequest,
    loadSharedAutoDeleteSuccess,
} from 'reactApp/modules/sharedAutoDelete/sharedAutoDelete.module';
import { cancel, put, select, take, takeEvery } from 'redux-saga/effects';

import { getHomeItemById } from '../home/home.selectors';
import { updateWeblinkAutoDelete } from '../modifying/modifying.actions';
import { normalizeAutoDeleteFolder } from './sharedAutoDelete.helpers';

function* loadSharedAutoDelete() {
    try {
        const res = yield Promise.resolve(api.folder.shared.links({ autodelete: true }));
        yield put(
            loadSharedAutoDeleteSuccess({
                list: [...res.list],
            })
        );
    } catch (error) {
        cancel();
    }
}

function* handleCreateSharedAutoDeleteStart(action: PayloadAction<any>) {
    const updateWeblinkAction: ReturnType<typeof updateWeblinkAutoDelete> = yield take(updateWeblinkAutoDelete);
    const item = action.payload;
    const { expires } = updateWeblinkAction.payload;
    const { weblink } = yield select(getHomeItemById, item.id);
    const autoDeleteFolder = normalizeAutoDeleteFolder({ ...item, weblink, weblinkAutoDelete: Boolean(expires), weblinkExpires: expires });
    yield put(createSharedAutoDeleteSuccess(autoDeleteFolder));
}

export function* watchSharedAutoDelete() {
    yield takeEvery(loadSharedAutoDeleteRequest.toString(), loadSharedAutoDelete);
    yield takeEvery(createSharedAutoDeleteStart.toString(), handleCreateSharedAutoDeleteStart);
}
